import React, { useMemo } from 'react';
import { Avatar } from '@mui/material';
import { getAvatar } from 'src/services/AssetApi';

const AvatarDisplay = ({ avatar, gender, size = 172, sx = {} }) => {
  const avatarSrc = useMemo(() => getAvatar(avatar, gender), [avatar, gender]);
  
  return (
    <Avatar
      src={avatarSrc}
      sx={{
        height: size,
        width: size,
        ...sx,
      }}
    />
  );
};

export default AvatarDisplay;
